<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'GradguardLogoIcon',
});
</script>
<!-- eslint-disable vue/max-len -->
<template>
  <svg viewBox="0 0 3000 1954">
    <path
      d="M1510.92 1332.27L639.992 860.491C639.992 860.491 611.009 1309.72 607.937 1360.21C604.865 1410.69 592.344 1514.8 674.887 1552.42C833.421 1626.44 1412.78 1895.46 1451.21 1910.64C1469.78 1919.58 1490.54 1922.92 1510.97 1920.26V1332.27H1510.92Z"
      fill="#1A3966"
    />
    <path
      d="M2405.32 1359.92C2400.68 1283.35 2387.12 954.162 2376.97 848.144L1502.63 1331.46V1921.25C1519.09 1920.15 1535.34 1916.91 1550.97 1911.63C1618.5 1891.22 2331.41 1521.23 2361.32 1503.44C2391.23 1485.64 2408.27 1451.62 2405.37 1359.92H2405.32Z"
      fill="#0F4B81"
    />
    <path
      d="M940.134 1457.18C953.775 1449.22 964.796 1437.45 971.845 1423.32C978.894 1409.18 981.666 1393.3 979.82 1377.61C977.973 1361.93 971.59 1347.12 961.452 1335.01C951.313 1322.9 937.861 1314.01 922.745 1309.43V956.596H856.491V1310.18C841.287 1315.28 827.846 1324.6 817.737 1337.05C807.628 1349.5 801.266 1364.57 799.395 1380.49C798.308 1396.93 802.138 1413.32 810.395 1427.58C818.653 1441.83 830.967 1453.31 845.767 1460.54C769.659 1528.77 764.616 1761.61 768.268 1919.22C768.268 1919.22 774.064 1954 903.5 1954C1032.94 1954 1057.75 1919.22 1057.75 1919.22C1057.75 1919.22 1041.52 1538.97 939.96 1457.12L940.134 1457.18Z"
      fill="#9BCA3C"
    />
    <path
      d="M2999.98 504.296L1489.41 0L0 515.367L1502.92 1331.4L2999.98 504.296Z"
      fill="#0F4B81"
    />
    <path
      d="M1502.92 1331.4L639.586 862.519L638.6 876.083L1497 1342.35L1502.8 1345.54L1508.6 1342.3L2378.07 862.113L2376.86 848.55L1502.92 1331.4Z"
      fill="#3D6D9B"
    />
  </svg>
</template>
